/**
 * O arquivo original numa aba nova, no visualizador do navegador (E184.F4.T01, GUS-145 item 3,
 * ADR-0136 §4). O PDF com texto se lê, seleciona e copia ali; a foto e a digitalização abrem como
 * imagem, como estão. Pela rota de visualização (E205.F4.C03, `visualizarArquivoOriginal`), para
 * quem enxerga o caso: o servidor confere que o documento é do caso e não entrega o guardado que não
 * confere com o recebido.
 *
 * A aba abre no clique, antes do download, para o navegador não a tratar como janela não pedida;
 * o endereço local do arquivo é revogado depois que a aba o carregou.
 */
import type { AxiosInstance } from 'axios';

import { classifyDocumentError, comCorpoLido } from './case_source_documents';

/**
 * O original do documento para MOSTRAR — o painel da mesa e a aba nova (E205.F4.C03, decisão do
 * owner de 01/11). Vale para quem enxerga o caso (o recorte é o da RLS); levar o arquivo embora é o
 * "Baixar" (`baixarArquivoOriginal`), pela rota auditada e com o recorte do acervo. O servidor
 * confere o caso e o hash do recebimento: o guardado que não confere não desce (409).
 */
export async function visualizarArquivoOriginal(
  client: AxiosInstance,
  caseId: string,
  docId: string,
): Promise<Blob> {
  try {
    const resposta = await client.get<Blob>(`/casos/${caseId}/documents/${docId}/visualizacao`, {
      responseType: 'blob',
    });
    return resposta.data;
  } catch (err) {
    throw classifyDocumentError(await comCorpoLido(err));
  }
}

/** Quanto o endereço local vive: o bastante para a aba nova carregar o arquivo. */
export const VIDA_DO_ENDERECO_MS = 60_000;

export async function abrirOriginalEmAbaNova(
  client: AxiosInstance,
  caseId: string,
  documentoId: string,
): Promise<void> {
  const aba = window.open('', '_blank');
  try {
    const blob = await visualizarArquivoOriginal(client, caseId, documentoId);
    const endereco = URL.createObjectURL(blob);
    if (aba === null) {
      window.open(endereco, '_blank', 'noopener');
    } else {
      aba.opener = null;
      aba.location.href = endereco;
    }
    window.setTimeout(() => URL.revokeObjectURL(endereco), VIDA_DO_ENDERECO_MS);
  } catch (err) {
    aba?.close();
    throw err;
  }
}
